import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HealthProfessionalService } from '@app/modules/health-professional/services/health-professional.service';
import { PetPatient } from '@app/shared/models/pet-patient';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalAddPatientComponent } from '../modal-add-patient/modal-add-patient.component';

@Component({
  selector: 'app-modal-select-pet',
  templateUrl: './modal-select-pet.component.html',
  styleUrls: ['./modal-select-pet.component.scss']
})
export class ModalSelectPetComponent implements OnInit {
  @Input() pets: any;
  @Input() prescriber: any;
  @Input() responsible: any;
  @Output() submit = new EventEmitter<any>();

  private prescriberPets: PetPatient[] = [];

  constructor(
    public modalRef: BsModalRef,
    private healthProfessionalService: HealthProfessionalService,
    private modalService: BsModalService
  ) {}

  ngOnInit(): void {
    this.healthProfessionalService
      .getPetsByResponsible(this.responsible._id)
      .subscribe((pets: PetPatient[]) => (this.prescriberPets = pets));
  }

  async addPetPatient(pet: PetPatient) {
    try {
      await this.healthProfessionalService.addPetPatient(pet._id).toPromise();
      this.submit.emit();
    } catch (err) {
      console.error(err);
    }
  }

  hasDependent(pet: PetPatient) {
    const pets = this.prescriberPets;
    return pets.find(p => p._id === pet._id);
  }

  showModalAddPatient() {
    const initialState = {
      prescriber: this.prescriber,
      patient: this.responsible,
      isResponsible: true,
      existingPatient: true
    };
    const modal = this.modalService.show(ModalAddPatientComponent, {
      class: 'modal-lg',
      initialState,
      backdrop: 'static',
      keyboard: false
    });

    modal.content.updateListPatientEvent.subscribe(_ => {
      this.submit.emit();
      this.modalRef.hide();
    });
  }
}
